import React from 'react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import useRecentlyViewedProducts from '@hooks/product/use-recently-viewed-products';

const PdpProductFeed = dynamic(() => import('@components/product/pdp-product-feed/pdp-product-feed'), { ssr: false });

const RecentlyViewedProducts: React.FC = () => {
  const { t } = useTranslation();

  const { recentlyViewedProducts } = useRecentlyViewedProducts();

  if (recentlyViewedProducts.length === 0) {
    return null;
  }

  return (
    <PdpProductFeed
      products={recentlyViewedProducts}
      productFeedCategory={'recently_viewed'}
      title={t('PRODUCT.RECENTLY_SEEN.TITLE')}
      productCardProps={{
        moduleType: 'recently_viewed_products',
        pageType: 'product_page',
      }}
    />
  );
};

export default RecentlyViewedProducts;
